/*
 *
 * FormIndicator constants
 *
 */

export const GET_SHOW_OTHER_INDICATOR_WATCHER =
  "app/FormIndicator/GET_SHOW_OTHER_INDICATOR_WATCHER"
export const GET_SHOW_OTHER_INDICATOR_SUCCESS =
  "app/FormIndicator/GET_SHOW_OTHER_INDICATOR_SUCCESS"
export const GET_SHOW_OTHER_INDICATOR_FAILED =
  "app/FormIndicator/GET_SHOW_OTHER_INDICATOR_FAILED"

export const SET_UPDATE_OTHER_INDICATOR_WATCHER =
  "app/FormIndicator/SET_UPDATE_OTHER_INDICATOR_WATCHER"
export const SET_UPDATE_OTHER_INDICATOR_SUCCESS =
  "app/FormIndicator/SET_UPDATE_OTHER_INDICATOR_SUCCESS"
export const SET_UPDATE_OTHER_INDICATOR_FAILED =
  "app/FormIndicator/SET_UPDATE_OTHER_INDICATOR_FAILED"
